<template>
  <div ref="header"
       :class="{ 'myHeader': color === 'light', 'myHeader2': color === 'dark', 'issFixed': headerFixed }"
       @mouseover="changeImg"
       @mouseout="changeImgD">
    <b-navbar toggleable="lg"
              type="dark"
              class="myNav"
              v-if="showChip">
      <!-- <b-navbar-brand href
                      v-if="color === 'light'">
        <h4>C302X</h4>
      </b-navbar-brand> -->
      <!-- <b-navbar-brand href
                      v-if="color === 'dark'">
        <h4>C302X</h4> -->
      </b-navbar-brand>
      <b-navbar-toggle target
                       @click="clickBtn"></b-navbar-toggle>
      <b-collapse id="nav-collapse"
                  is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <b-nav-item :to="{name:'module_detail',query:{id:'capture'}}"
                        :active="activeMenu=='home'"
                        :class="{chinese:showchinese}">特性</b-nav-item>
            <b-nav-item :class="{chinese:showchinese}"
                        :active="activeMenu=='platform'"
                        :to="{name:'module_table',query:{id:'capture'}}"
                        >参数</b-nav-item>
            <b-nav-item :class="{chinese:showchinese}"
                        :active="activeMenu=='ai'"
                        >维基</b-nav-item>

            <b-nav-item :class="{chinese:showchinese}"
                        :active="activeMenu=='newsolution'"
                        >技术案例</b-nav-item>
            <!-- <b-nav-item to="joinUs" :active="activeMenu=='joinUs'">{{$t('navtopjoinUS')}}</b-nav-item> -->
            <!-- <b-nav-item to="about" :active="activeMenu=='about'">{{$t('navtopabout')}}</b-nav-item>
            <b-nav-item to="product" :active="activeMenu=='product'">{{$t('navtopproduct')}}</b-nav-item>
            <b-nav-item to="solution" :active="activeMenu=='solution'">{{$t('navtopsolution')}}</b-nav-item>-->
            <!-- <b-nav-item to="joinUs" :active="activeMenu=='joinUs'">{{$t('navtopjoinUS')}}</b-nav-item> -->
            <b-nav-item :class="{chinese:showchinese}"
                        :to="{name:'module_detail',query:{id:'capture'}}"
                        :active="activeMenu=='about'">下载</b-nav-item>

            <!-- <b-nav-item :class="{chinese:showchinese}"
                        href="http://confluence.neucore.com"
                        :active="activeMenu=='about'">{{$t('navtopKnowledge')}}</b-nav-item> -->
          </b-navbar-nav>

          <b-nav-item v-show="showenglish"
                      @click="changeType('zh');changeLangue()">中文</b-nav-item>

          <b-nav-item v-show="showchinese"
                      @click="changeType('en');changeLangue()">English</b-nav-item>

          <!-- <b-nav-item-dropdown right> -->
          <!-- Using 'button-content' slot -->
          <!-- <template v-slot:button-content>
              <em>User</em>
            </template>
            <b-dropdown-item to="about" >Profile</b-dropdown-item>
            <b-dropdown-item to="about" >Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>-->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-navbar toggleable="lg"
              type="dark"
              v-else
              class="myNav">
      <b-navbar-brand href
                      v-if="color === 'light'">
        <b-img fluid
               src="img/logo_white.png"
               alt="Image 1"></b-img>
      </b-navbar-brand>
      <b-navbar-brand href
                      v-if="color === 'dark'">
        <b-img fluid
               :src="logoSrc"
               alt="Image 1"></b-img>
      </b-navbar-brand>
      <b-navbar-toggle target
                       @click="clickBtn"></b-navbar-toggle>
      <b-collapse id="nav-collapse"
                  is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <b-nav-item to="home"
                        :active="activeMenu=='home'"
                        :class="{chinese:showchinese}">{{$t('navtophome')}}</b-nav-item>
            <b-nav-item :class="{chinese:showchinese}"
                        :active="activeMenu=='platform'"
                        @mouseenter="showAICon('platform')"
                        @mouseleave="hideAICon('platform')">{{$t('navtopOpen')}}</b-nav-item>
            <b-nav-item :class="{chinese:showchinese}"
                        :active="activeMenu=='ai'"
                        @mouseenter="showAICon('ai')"
                        @mouseleave="hideAICon('ai')">{{$t('navtopTechnical')}}</b-nav-item>

            <b-nav-item :class="{chinese:showchinese}"
                        :active="activeMenu=='newsolution'"
                        @mouseenter="showAICon('solution')"
                        @mouseleave="hideAICon('solution')">{{$t('navtopTurnkey')}}</b-nav-item>
            <!-- <b-nav-item to="joinUs" :active="activeMenu=='joinUs'">{{$t('navtopjoinUS')}}</b-nav-item> -->
            <!-- <b-nav-item to="about" :active="activeMenu=='about'">{{$t('navtopabout')}}</b-nav-item>
            <b-nav-item to="product" :active="activeMenu=='product'">{{$t('navtopproduct')}}</b-nav-item>
            <b-nav-item to="solution" :active="activeMenu=='solution'">{{$t('navtopsolution')}}</b-nav-item>-->
            <!-- <b-nav-item to="joinUs" :active="activeMenu=='joinUs'">{{$t('navtopjoinUS')}}</b-nav-item> -->
            <b-nav-item :class="{chinese:showchinese}"
                        href="https://support.qq.com/products/593793/"
                        target="_blank"
                        :active="activeMenu=='tech'">{{$t('navtoptech')}}</b-nav-item>
            <b-nav-item :class="{chinese:showchinese}"
                        to="about"
                        :active="activeMenu=='about'">{{$t('navtopAbout')}}</b-nav-item>

            <!-- <b-nav-item :class="{chinese:showchinese}"
                        href="http://confluence.neucore.com"
                        :active="activeMenu=='about'">{{$t('navtopKnowledge')}}</b-nav-item> -->
          </b-navbar-nav>

          <b-nav-item v-show="showenglish"
                      @click="changeType('zh');changeLangue()">中文</b-nav-item>

          <b-nav-item v-show="showchinese"
                      @click="changeType('en');changeLangue()">English</b-nav-item>

          <!-- <b-nav-item-dropdown right> -->
          <!-- Using 'button-content' slot -->
          <!-- <template v-slot:button-content>
              <em>User</em>
            </template>
            <b-dropdown-item to="about" >Profile</b-dropdown-item>
            <b-dropdown-item to="about" >Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>-->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div class="background"
         v-if="open"
         @click.self="closeDrop">
      <div class="drop"
           :class="{ active: isActive, close: isClose }">
        <div role="tablist">
          <b-card no-body
                  class="mb-1">
            <b-card-header header-tag="header"
                           class="p-1"
                           role="tab">
              <b-button block
                        to="home"
                        @click.self="closeDrop"
                        variant="info">{{$t('navtophome')}}</b-button>
            </b-card-header>
          </b-card>

          <b-card no-body
                  class="mb-1">
            <b-card-header header-tag="header"
                           class="p-1"
                           role="tab">
              <b-button block
                        v-b-toggle.accordion-3
                        variant="info"
                        class="accordiy">{{$t('navtopOpen')}}</b-button>
            </b-card-header>
            <b-collapse id="accordion-3"
                        accordion="my-accordion"
                        role="tabpanel">
              <b-card-body>
                <b-list-group flush>

                  <b-list-group-item @click="showmore('module')">{{$t('homenavModule')}}</b-list-group-item>
                  <div v-show="module"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'module_detail',query:{id:'capture'}}">{{$t('homenavModule0')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'module_detail',query:{id:'recognition'}}">{{$t('homenavModule1')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'module_detail',query:{id:'plate'}}">{{$t('homenavModule2')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'module_detail',query:{id:'all'}}">{{$t('homenavModule3')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'module_detail',query:{id:'ipc'}}">{{$t('homenavModule4')}}</b-list-group-item>
                    </b-list-group>
                  </div>

                  <b-list-group-item @click="showmore('softhard')">{{$t('homenav2SNT')}}</b-list-group-item>
                  <div v-show="softhard"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'camera_detail',query:{id:'all'}}">{{$t('homenav2SNT0')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'camera_detail',query:{id:'ipc'}}">{{$t('homenav2SNT1')}}</b-list-group-item>
                    </b-list-group>
                  </div>

                  <b-list-group-item @click="showmore('equip')">{{$t('homenav2HPT')}}</b-list-group-item>
                  <div v-show="equip"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'board_detail',query:{id:'neuboard'}}">{{$t('homenav2HPT0')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'board_detail',query:{id:'develop'}}">{{$t('homenav2HPT1')}}</b-list-group-item>
                      <!-- <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'hardware',query:{id:'audio'}}">{{$t('homenav2HPT2')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'hardware',query:{id:'camera'}}">{{$t('homenav2HPT3')}}</b-list-group-item> -->
                    </b-list-group>
                  </div>

                  <b-list-group-item @click="showmore('service')">{{$t('homenav2SPT')}}</b-list-group-item>
                  <div v-show="service"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'sdk',query:{id:'linux'}}">{{$t('homenav2SPT0')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'sdk',query:{id:'android'}}">{{$t('homenav2SPT1')}}</b-list-group-item>
                    </b-list-group>
                  </div>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body
                  class="mb-1">
            <b-card-header header-tag="header"
                           class="p-1"
                           role="tab">
              <b-button block
                        to
                        v-b-toggle.accordion-1
                        variant="info"
                        class="btn-info">{{$t('navtopTechnical')}}</b-button>
            </b-card-header>
            <b-collapse id="accordion-1"
                        accordion="my-accordion"
                        role="tabpanel"
                        class="accordiy">
              <b-card-body>
                <b-list-group flush>
                  <b-list-group-item @click="showmore('face')">{{$t('homenavFT')}}</b-list-group-item>
                  <div v-show="mobileFace"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'face',query:{id:'face'}}">{{$t('homenavFT0')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'face',query:{id:'eigenvalues'}}">{{$t('homenavFT7')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'face',query:{id:'multiface'}}">{{$t('homenavFT1')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'face',query:{id:'faceattribute'}}">{{$t('homenavFT2')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'face',query:{id:'facekeyframe'}}">{{$t('homenavFT8')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'face',query:{id:'location'}}">{{$t('homenavFT3')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'face',query:{id:'recognition'}}">{{$t('homenavFT4')}}</b-list-group-item>
                      <!-- <b-list-group-item
                        @click.self="closeDrop"
                        :to="{name:'face',query:{id:'antispoofing'}}"
                      >{{$t('homenavFT6')}}</b-list-group-item> -->
                      <!-- <b-list-group-item to="/finger">{{$t('homenavBT3')}}</b-list-group-item> -->
                    </b-list-group>
                  </div>
                </b-list-group>

                <b-list-group flush>
                  <b-list-group-item @click="showmore('body')">{{$t('homenavBT')}}</b-list-group-item>
                  <div v-show="mobileBody"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'body',query:{id:'human'}}">{{$t('homenavBT0')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'body',query:{id:'re-id'}}">{{$t('homenavBT1')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'body',query:{id:'gesture'}}">{{$t('homenavBT2')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'body',query:{id:'pose'}}">{{$t('homenavBT3')}}</b-list-group-item>
                    </b-list-group>
                  </div>
                </b-list-group>

                <b-list-group flush>
                  <b-list-group-item @click="showmore('auto')">{{$t('homenavCT')}}</b-list-group-item>

                  <div v-show="mobileCar"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'auto' ,query:{id:'detection'}}">{{$t('homenavCT0')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'auto' ,query:{id:'carplate'}}">{{$t('homenavCT3')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'auto' ,query:{id:'recognition'}}">{{$t('homenavCT1')}}</b-list-group-item>

                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'auto' ,query:{id:'attribute'}}">{{$t('homenavCT2')}}</b-list-group-item>
                    </b-list-group>
                  </div>
                </b-list-group>

                <b-list-group flush>
                  <b-list-group-item @click="showmore('object')">{{$t('homenavOT')}}</b-list-group-item>

                  <div v-show="mobileObject"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'object',query:{id:'logo'}}">{{$t('homenavOT0')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'object',query:{id:'unknowleft'}}">{{$t('homenavOT1')}}</b-list-group-item>
                      <b-list-group-item @click.self="closeDrop"
                                         :to="{name:'object',query:{id:'helmet'}}">{{$t('homenavOT2')}}</b-list-group-item>
                    </b-list-group>
                  </div>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body
                  class="mb-1">
            <b-card-header header-tag="header"
                           class="p-1"
                           role="tab">
              <b-button block
                        v-b-toggle.accordion-2
                        variant="info"
                        class="accordiy">{{$t('navtopTurnkey')}}</b-button>
            </b-card-header>
            <b-collapse id="accordion-2"
                        accordion="my-accordion"
                        role="tabpanel">
              <b-card-body>
                <!-- <b-list-group flush>
                  <b-list-group-item @click="showmore('sale')">{{$t('homenav1RT')}}</b-list-group-item>
                  <div v-show="sale"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click="returnTop('picture')"
                                         @click.self="closeDrop"
                                         :to="{name:'retail',query:{id:'picture'}}">{{$t('homenav1RT0')}}</b-list-group-item>
                      <b-list-group-item @click="returnTop('store')"
                                         @click.self="closeDrop"
                                         :to="{name:'retail',query:{id:'store'}}">{{$t('homenav1RT1')}}</b-list-group-item>
                      <b-list-group-item @click="returnTop('customer')"
                                         @click.self="closeDrop"
                                         :to="{name:'retail',query:{id:'customer'}}">{{$t('homenav1RT2')}}</b-list-group-item>
                    </b-list-group>
                  </div> -->

                  <b-list-group-item @click="showmore('enterprise')">{{$t('homenav1ET')}}</b-list-group-item>
                  <div v-show="enterprise"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click="returnTop('body')"
                                         @click.self="closeDrop"
                                         :to="{name:'safety',query:{id:'body'}}">{{$t('homenav1ET1')}}</b-list-group-item>
                      <b-list-group-item @click="returnTop('car')"
                                         @click.self="closeDrop"
                                         :to="{name:'safety',query:{id:'car'}}">{{$t('homenav1ET2')}}</b-list-group-item>
                      <b-list-group-item @click="returnTop('object')"
                                         @click.self="closeDrop"
                                         :to="{name:'safety',query:{id:'object'}}">{{$t('homenav1ET3')}}</b-list-group-item>
                    </b-list-group>
                  </div>

                  <b-list-group-item @click="showmore('building')">{{$t('homenav1BT')}}</b-list-group-item>
                  <div v-show="building"
                       class="animated">
                    <b-list-group flush>
                      <b-list-group-item @click="returnTop('driver')"
                                         @click.self="closeDrop"
                                         :to="{name:'car',query:{id:'driver'}}">{{$t('homenav1BT0')}}</b-list-group-item>
                      <b-list-group-item @click="returnTop('drive')"
                                         @click.self="closeDrop"
                                         :to="{name:'car',query:{id:'drive'}}">{{$t('homenav1BT1')}}</b-list-group-item>
                    </b-list-group>
                  </div>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body
                  class="mb-1">
            <b-card-header header-tag="header"
                           class="p-1"
                           role="tab">
              <b-button block
                        href="https://support.qq.com/products/593793/"
                        variant="info"
                        @click.self="closeDrop">{{$t('navtoptech')}}</b-button>
            </b-card-header>
          </b-card>

          <b-card no-body
                  class="mb-1">
            <b-card-header header-tag="header"
                           class="p-1"
                           role="tab">
              <b-button block
                        to="about"
                        variant="info"
                        @click.self="closeDrop">{{$t('navtopAbout')}}</b-button>
            </b-card-header>
          </b-card>

          <!-- <b-card no-body
                  class="mb-1">
            <b-card-header header-tag="header"
                           class="p-1"
                           role="tab">
              <b-button block
                        href="http://confluence.neucore.com"
                        variant="info">{{$t('navtopKnowledge')}}</b-button>
            </b-card-header>
          </b-card> -->

          <b-card no-body
                  v-show="showchinese"
                  @click="changeType('en')"
                  class="mb-1">
            <b-card-header header-tag="header"
                           class="p-1"
                           role="tab">
              <b-button block
                        variant="info">English</b-button>
            </b-card-header>
          </b-card>

          <b-card no-body
                  v-show="showenglish"
                  @click="changeType('zh')"
                  class="mb-1">
            <b-card-header header-tag="header"
                           class="p-1"
                           role="tab">
              <b-button block
                        variant="info">中文</b-button>
            </b-card-header>
          </b-card>
        </div>
      </div>
    </div>

    <div class="aiEngineer"
         v-show="showAi"
         @mouseenter="showAICon('ai')"
         @mouseleave="hideAICon('ai')">
      <div class="navMore"
           v-show="navMore">
        <div class="nav_ri"
             v-show="secondMenu==1">
          <div class="carSec">
            <h4>{{$t('homenavCT')}}</h4>
            <ul>
              <router-link to="/ai">{{$t('homenavCT1')}}</router-link>
              <router-link to="/ai">{{$t('homenavCT0')}}</router-link>
              <router-link to="/ai">{{$t('homenavCT2')}}</router-link>
            </ul>
          </div>
        </div>
        <div class="nav_ri"
             v-show="secondMenu==2">
          <div class="carSec">
            <h4>{{$t('homenavFT')}}</h4>
            <ul>
              <li>{{$t('homenavFT')}}</li>
              <li>{{$t('homenavFT0')}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="navbase">
        <div class="nbsec">
          <router-link :to="{name:'face'}">
            <h5>{{$t('homenavFT')}}</h5>
          </router-link>
          <ul>
            <li>
              <router-link :to="{name:'face',query:{id:'face'}}">{{$t('homenavFT0')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'face',query:{id:'eigenvalues'}}">{{$t('homenavFT7')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'face',query:{id:'multiface'}}">{{$t('homenavFT1')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'face',query:{id:'faceattribute'}}">{{$t('homenavFT2')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'face',query:{id:'facekeyframe'}}">{{$t('homenavFT8')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'face',query:{id:'location'}}">{{$t('homenavFT3')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'face',query:{id:'recognition'}}">{{$t('homenavFT4')}}</router-link>
            </li>
            <!-- <li>
              <router-link :to="{name:'face',query:{id:'vertification'}}">{{$t('homenavFT5')}}</router-link>
            </li> -->
            <!-- <li>
              <router-link :to="{name:'face',query:{id:'antispoofing'}}">{{$t('homenavFT6')}}</router-link>
            </li> -->
          </ul>
        </div>
        <div class="nbsec">
          <router-link :to="{name:'body'}">
            <h5>{{$t('homenavBT')}}</h5>
          </router-link>
          <ul>
            <li>
              <router-link :to="{name:'body',query:{id:'human'}}">{{$t('homenavBT0')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'body',query:{id:'re-id'}}">{{$t('homenavBT1')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'body',query:{id:'gesture'}}">{{$t('homenavBT2')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'body',query:{id:'pose'}}">{{$t('homenavBT3')}}</router-link>
              <!-- <router-link to="/finger">{{$t('homenavBT3')}}</router-link> -->
            </li>
          </ul>
        </div>
        <div class="nbsec">
          <router-link :to="{name:'auto'}">
            <h5 class="rTcar"
                @click="moveTC">{{$t('homenavCT')}}</h5>
          </router-link>

          <ul>
            <li>
              <router-link :to="{name:'auto',query:{id:'detection'}}">{{$t('homenavCT0')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'auto',query:{id:'carplate'}}">{{$t('homenavCT3')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'auto',query:{id:'recognition'}}">{{$t('homenavCT1')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'auto',query:{id:'attribute'}}">{{$t('homenavCT2')}}</router-link>
            </li>
          </ul>
        </div>
        <div class="nbsec">
          <router-link :to="{name:'object'}">
            <h5 class="rTcar"
                @click="moveTC">{{$t('homenavOT')}}</h5>
          </router-link>
          <ul>
            <li>
              <router-link :to="{name:'object',query:{id:'logo'}}">{{$t('homenavOT0')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'object',query:{id:'unknowleft'}}">{{$t('homenavOT1')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'object',query:{id:'helmet'}}">{{$t('homenavOT2')}}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="aiEngineer"
         v-show="showSolution"
         @mouseenter="showAICon('solution')"
         @mouseleave="hideAICon('solution')">
      <div class="navbase special">
        <b-row>
          <!-- <div class="nbsec">
            <router-link :to="{name:'retail'}">
              <h5 class="rTcar nborder"
                  @click="moveTC">{{$t('homenav1RT')}}</h5>
            </router-link>
            <ul>
              <li @click="returnTop('picture')">
                <router-link :to="{name:'retail',query:{id:'picture'}}">{{$t('homenav1RT0')}}</router-link>
              </li>
              <li @click="returnTop('store')">
                <router-link :to="{name:'retail',query:{id:'store'}}">{{$t('homenav1RT1')}}</router-link>
              </li>
              <li @click="returnTop('customer')">
                <router-link :to="{name:'retail',query:{id:'customer'}}">{{$t('homenav1RT2')}}</router-link>
              </li>
            </ul>
          </div> -->
          <div class="nbsec">
            <router-link :to="{name:'safety'}">
              <h5 class="nborder">{{$t('homenav1ET')}}</h5>
            </router-link>
            <ul>
              <li @click="returnTop('body')">
                <router-link :to="{name:'safety',query:{id:'body'}}">{{$t('homenav1ET1')}}</router-link>
              </li>
              <li @click="returnTop('car')">
                <router-link :to="{name:'safety',query:{id:'car'}}">{{$t('homenav1ET2')}}</router-link>
              </li>
              <li @click="returnTop('object')">
                <router-link :to="{name:'safety',query:{id:'object'}}">{{$t('homenav1ET3')}}</router-link>
              </li>
              <!-- <li @click="returnTop('security')">
                <router-link :to="{name:'education',query:{id:'security'}}">{{$t('homenav1ET4')}}</router-link>
              </li> -->
            </ul>
          </div>
          <div class="nbsec">
            <router-link :to="{name:'car'}">
              <h5 class="nborder">{{$t('homenav1BT')}}</h5>
            </router-link>
            <ul>
              <li @click="returnTop('driver')">
                <router-link :to="{name:'car',query:{id:'driver'}}">{{$t('homenav1BT0')}}</router-link>
              </li>
              <li @click="returnTop('drive')">
                <router-link :to="{name:'car',query:{id:'drive'}}">{{$t('homenav1BT1')}}</router-link>
              </li>
              <!-- <li @click="returnTop('visitor')">
                <router-link :to="{name:'building',query:{id:'visitor'}}">{{$t('homenav1BT2')}}</router-link>
              </li>
              <li @click="returnTop('advertisement')">
                <router-link :to="{name:'building',query:{id:'advertisement'}}">{{$t('homenav1BT3')}}</router-link>
              </li> -->
            </ul>
          </div>
          <!-- <div class="nbsec">
            <router-link :to="{name:'factory'}">
              <h5>{{$t('homenav1FT')}}</h5>
            </router-link>
            <ul>
              <li @click="returnTop('label')">
                <router-link :to="{name:'factory',query:{id:'label'}}">{{$t('homenav1FT0')}}</router-link>
              </li>
              <li @click="returnTop('object')">
                <router-link :to="{name:'factory',query:{id:'object'}}">{{$t('homenav1FT1')}}</router-link>
              </li>
              <li @click="returnTop('area')">
                <router-link :to="{name:'factory',query:{id:'area'}}">{{$t('homenav1FT2')}}</router-link>
              </li>
            </ul>
          </div> -->
        </b-row>
        <!-- <b-row>
          <div class="nbsec">
            <router-link :to="{name:'car'}">
              <h5>{{$t('homenav1CT')}}</h5>
            </router-link>
            <ul>
              <li @click="returnTop('passenger')">
                <router-link :to="{name:'car',query:{id:'passenger'}}">{{$t('homenav1CT0')}}</router-link>
              </li>
              <li @click="returnTop('criminal')">
                <router-link :to="{name:'car',query:{id:'criminal'}}">{{$t('homenav1CT1')}}</router-link>
              </li>
              <li @click="returnTop('fatigue')">
                <router-link :to="{name:'car',query:{id:'fatigue'}}">{{$t('homenav1CT2')}}</router-link>
              </li>
            </ul>
          </div>

          <div class="nbsec">
            <router-link :to="{name:'field'}">
              <h5>{{$t('homenav1SCT')}}</h5>
            </router-link>
            <ul>
              <li @click="returnTop('helmet')">
                <router-link :to="{name:'field',query:{id:'helmet'}}">{{$t('homenav1SCT0')}}</router-link>
              </li>
              <li @click="returnTop('gate')">
                <router-link :to="{name:'field',query:{id:'gate'}}">{{$t('homenav1SCT1')}}</router-link>
              </li>
              <li @click="returnTop('worker')">
                <router-link :to="{name:'field',query:{id:'worker'}}">{{$t('homenav1SCT2')}}</router-link>
              </li>
            </ul>
          </div>

          <div class="nbsec">
            <router-link :to="{name:'hospital'}">
              <h5>{{$t('homenav1SHT')}}</h5>
            </router-link>

            <ul>
              <li @click="returnTop('face')">
                <router-link :to="{name:'hospital',query:{id:'face'}}">{{$t('homenav1SHT0')}}</router-link>
              </li>
              <li @click="returnTop('blacklist')">
                <router-link :to="{name:'hospital',query:{id:'blacklist'}}">{{$t('homenav1SHT1')}}</router-link>
              </li>
            </ul>
          </div>

          <div class="nbsec">
            <router-link :to="{name:'parking'}">
              <h5>{{$t('homenav1SPT')}}</h5>
            </router-link>

            <ul>
              <li @click="returnTop('location')">
                <router-link :to="{name:'parking',query:{id:'location'}}">{{$t('homenav1SPT1')}}</router-link>
              </li>
              <li @click="returnTop('charge')">
                <router-link :to="{name:'parking',query:{id:'charge'}}">{{$t('homenav1SPT0')}}</router-link>
              </li>

            </ul>
          </div>
        </b-row> -->
      </div>
    </div>

    <div class="aiEngineer"
         v-show="showPlatform"
         @mouseenter="showAICon('platform')"
         @mouseleave="hideAICon('platform')">
      <div class="navbase">

        <!-- <div class="nbsec">
          <router-link :to="{name:'module'}">
            <h5>嵌入式主板</h5>
          </router-link>

          <ul>
            <li>
              <router-link target="_blank" :to="{name:'module_detail',query:{id:'capture'}}">C302X</router-link>
            </li>
          </ul>
        </div> -->

        <div class="nbsec">
          <router-link :to="{name:'camera'}">
            <h5>{{$t('homenav2SNT')}}</h5>
          </router-link>

          <ul>
            <li>
              <router-link :to="{name:'camera_detail',query:{id:'all'}}">{{$t('homenav2SNT0')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'camera_detail',query:{id:'ipc'}}">{{$t('homenav2SNT1')}}</router-link>
            </li>
          </ul>
        </div>

        <!-- <div class="nbsec">
          <router-link :to="{name:'board'}">
            <h5 class="rTcar"
                @click="moveTC">{{$t('homenav2HPT')}}</h5>
          </router-link>

          <ul>
            <li>
              <router-link :to="{name:'board_detail',query:{id:'neuboard'}}">{{$t('homenav2HPT0')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'board_detail',query:{id:'develop'}}">{{$t('homenav2HPT1')}}</router-link>
            </li>
          </ul>
        </div> -->
        <div class="nbsec">
          <router-link :to="{name:'sdk'}">
            <h5>{{$t('homenav2SPT')}}</h5>
          </router-link>

          <ul>
            <li>
              <router-link :to="{name:'sdk',query:{id:'linux'}}">{{$t('homenav2SPT0')}}</router-link>
            </li>
            <li>
              <router-link :to="{name:'sdk',query:{id:'android'}}">{{$t('homenav2SPT1')}}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <b-modal class="modal fade"
             id="modalContact"
             tabindex="-1"
             role="dialog"
             aria-labelledby="myModalLabel"
             aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{$t('TopContact')}}</h4>
            <!-- <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button> -->
          </div>
          <div class="modal-body">
            <form id="contactForm"
                  method="post"
                  class="form"
                  role="form"
                  style="padding: 20px 0 ">
              <div class="row"
                   style="margin-bottom: 10px">
                <div class="col-xs-9 col-md-6 form-group">
                  <input class="form-control"
                         id="name"
                         name="name"
                         placeholder="Name"
                         type="text"
                         required
                         v-model="companyName" />
                </div>
                <div class="col-xs-9 col-md-6 form-group">
                  <input class="form-control"
                         id="email"
                         name="email"
                         placeholder="Email"
                         type="email"
                         v-model="email"
                         required />
                </div>
              </div>
              <textarea class="form-control"
                        id="message"
                        name="message"
                        placeholder="Message"
                        rows="5"
                        v-model="message"
                        required></textarea>

              <div class="row"
                   style="margin-top: 31px;">
                <div class="col-xs-12 col-md-12 text-center contact">
                  <button class="btn btn btn-lg sendEmail"
                          type="button"
                          @click="sendMesg">{{$t(changeMSg)}}</button>
                </div>
              </div>
            </form>
          </div>
          <!-- <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>-->
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
export default {
  name: 'topNav',
  props: ['color'],
  data() {
    return {
      offsetTop: 0,
      offsetHeight: 0,
      headerFixed: 0,
      showChip: false,
      companyName: '',
      email: '',
      message: '',
      changeMSg: 'Send Message',
      showAi: false,
      showSolution: false,
      showPlatform: false,
      secondMenu: 1,
      screenWidth: document.body.clientWidth,
      showNav: true,
      open: false,
      isActive: false,
      isClose: false,
      navMore: false,
      mobileCar: false,
      mobileFace: false,
      mobileBody: false,
      mobileObject: false,
      info: false,

      module: false,
      enterprise: false,
      sale: false,
      building: false,
      factory: false,
      bus: false,
      site: false,
      hospital: false,
      park: false,

      equip: false,
      service: false,
      hardware: false,
      softhard: false,
      showenglish: false,
      showchinese: true,
      logoSrc: 'img/logo_black.png',
      oldcolor: '',

      list: [
        {
          h: 'homenav1RT0',
          p: [
            // 'homenav1RT0P0',
            // 'homenav1RT0P1',
            // 'homenav1RT0P2',
            // 'homenav1RT0P3'
          ],
          showContent: true,
          imgSrc:
            'https://ai.bdstatic.com/file/786A7AC051294F95A2323E23B28233C9'
        },
        {
          h: 'homenav1RT1',
          p: [
            // 'homenav1RT1P0',
            // 'homenav1RT1P1',
            // 'homenav1RT1P2',
            // 'homenav1RT1P3'
          ],
          showContent: false,
          imgSrc:
            'https://ai.bdstatic.com/file/A7779FB3A6B846D38BDF4229DAB380C7'
        },
        {
          h: 'homenav1RT2',
          p: [
            // 'homenav1RT2P0',
            // 'homenav1RT2P1',
            // 'homenav1RT2P2',
            // 'homenav1RT2P3'
          ],
          showContent: false,
          imgSrc:
            'https://ai.bdstatic.com/file/E025C565815F4997B0CA9E2C9864931B'
        },
        {
          h: 'homenav1RT3',
          p: [
            'homenav1RT3P0',
            'homenav1RT3P1',
            'homenav1RT3P2',
            'homenav1RT3P3'
          ],
          showContent: false,
          imgSrc:
            'https://ai.bdstatic.com/file/9C9E873AC82E4E18A1FE1397C5094BEB'
        },
        {
          h: 'homenav1RT4',
          p: ['homenav1RT4P0', 'homenav1RT4P1', 'homenav1RT4P2'],
          showContent: false,
          imgSrc:
            'https://ai.bdstatic.com/file/2E741362FD7C4A80AF4ACD209669C389'
        },
        {
          h: 'homenav1RT5',
          p: ['homenav1RT5P0', 'homenav1RT5P1'],
          showContent: false,
          imgSrc:
            'https://ai.bdstatic.com/file/59C3B1F1C89349639547D55C05EE9A35'
        }
      ],
      tabIndex: 0
    }
  },
  methods: {
    returnTop(ele) {
      document.querySelector('#' + ele).scrollIntoView(true)
    },
    changeImg() {
      this.logoSrc = 'img/logo_white.png'
    },
    changeImgD() {
      if (this.color == 'dark') {
        this.logoSrc = 'img/logo_black.png'
      }
    },
    moveTC() {
      this.$router.push('car')
    },
    showmore(val) {
      switch (val) {
        case 'auto':
          this.mobileFace = false
          this.mobileBody = false
          this.mobileObject = false
          this.module = false
          this.mobileCar = !this.mobileCar
          break
        case 'body':
          this.mobileFace = false
          this.mobileObject = false
          this.mobileCar = false
          this.module = false
          this.mobileBody = !this.mobileBody
          break
        case 'object':
          this.mobileFace = false
          this.mobileBody = false
          this.mobileCar = false
          this.module = false
          this.mobileObject = !this.mobileObject
          break
        case 'face':
          this.mobileCar = false
          this.mobileBody = false
          this.mobileObject = false
          this.module = false
          this.mobileFace = !this.mobileFace
          break

        case 'sale':
          this.enterprise = false
          this.building = false
          this.factory = false
          this.bus = false
          this.site = false
          this.hospital = false
          this.park = false
          this.sale = !this.sale
          break

        case 'enterprise':
          this.sale = false
          this.building = false
          this.factory = false
          this.bus = false
          this.site = false
          this.hospital = false
          this.park = false
          this.enterprise = !this.enterprise
          break

        case 'building':
          this.enterprise = false
          this.sale = false
          this.factory = false
          this.bus = false
          this.site = false
          this.hospital = false
          this.park = false
          this.building = !this.building
          break

        case 'factory':
          this.enterprise = false
          this.sale = false
          this.building = false
          this.bus = false
          this.site = false
          this.hospital = false
          this.park = false
          this.factory = !this.factory
          break

        case 'bus':
          this.enterprise = false
          this.sale = false
          this.building = false
          this.factory = false
          this.site = false
          this.hospital = false
          this.park = false
          this.bus = !this.bus
          break

        case 'site':
          this.enterprise = false
          this.sale = false
          this.building = false
          this.factory = false
          this.bus = false
          this.hospital = false
          this.park = false
          this.site = !this.site
          break

        case 'hospital':
          this.enterprise = false
          this.sale = false
          this.building = false
          this.factory = false
          this.site = false
          this.bus = false
          this.park = false
          this.hospital = !this.hospital
          break

        case 'park':
          this.enterprise = false
          this.sale = false
          this.building = false
          this.factory = false
          this.site = false
          this.hospital = false
          this.bus = false
          this.park = !this.park
          break
        case 'module':
          this.mobileFace = false
          this.mobileBody = false
          this.mobileObject = false
          this.mobileCar = false
          this.service = false
          this.softhard = false
          this.equip = false
          this.module = !this.module
          break
        case 'equip':
          this.module = false
          this.service = false
          this.softhard = false
          this.equip = !this.equip
          break
        case 'service':
          this.equip = false
          this.softhard = false
          this.module = false
          this.service = !this.service
          break
        case 'softhard':
          this.equip = false
          this.service = false
          this.module = false
          this.softhard = !this.softhard
          break
      }
    },
    clickBtn() {
      this.open = true
      this.isActive = true
      this.isClose = false
    },
    closeDrop() {
      this.isClose = true
      setTimeout(() => {
        this.open = false
      }, 200)
    },
    showAICon(sec) {
      switch (sec) {
        case 'ai':
          if (this.screenWidth > 992 || this.screenWidth == 992) {
            this.showAi = true
          }
          break
        case 'solution':
          if (this.screenWidth > 992 || this.screenWidth == 992) {
            this.showSolution = true
          }
          break
        case 'platform':
          if (this.screenWidth > 992 || this.screenWidth == 992) {
            this.showPlatform = true
          }
          break
      }
    },
    hideAICon(sec) {
      switch (sec) {
        case 'ai':
          if (this.screenWidth > 992 || this.screenWidth == 992) {
            this.showAi = false
          }
          break
        case 'solution':
          if (this.screenWidth > 992 || this.screenWidth == 992) {
            this.showSolution = false
          }
          break
        case 'platform':
          if (this.screenWidth > 992 || this.screenWidth == 992) {
            this.showPlatform = false
          }
          break
      }
    },
    changeSecondMenu(val) {
      this.secondMenu = val
    },
    handleSelect(key, keyPath) {
      window.console.log(key, keyPath)
    },
    ...mapMutations({
      ChangeLangue: 'changeLangue'
    }),
    changeLangue() {
      this.ChangeLangue()
    },
    changeType(type) {
      localStorage.getItem('locale', type)
      this.$i18n.locale = type
      if (type == 'zh') {
        this.showenglish = false
        this.showchinese = true
      } else {
        this.showenglish = true
        this.showchinese = false
      }
    },
    handleScroll() {
      // 得到页面滚动的距离，兼容写法
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      // 判断页面滚动的距离是否大于吸顶元素的位置
      if ( scrollTop + 30 > this.offsetHeight ) {
        this.headerFixed = true
      } else {
        this.headerFixed = false
      }
      // this.headerFixed = scrollTop + 30 > this.offsetHeight && this.$route.name != 'module_detail'
    },
    sendMesg() {
      var reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
      var data = {
        user_name: this.companyName,
        e_mail: this.email,
        content: this.message,
        type: 0
      }
      if (data.user_name == '') {
        // toastr.error("Name is required");
        return
      } else if (data.e_mail == '') {
        // toastr.error("Email is required");
        return
      } else if (!reg.test(data.e_mail)) {
        // toastr.error("E-mail format is incorrect");
        this.$bvToast.toast('邮箱格式不正确', {
          title: `消息提醒`,
          variant: 'danger',
          solid: true
        })
        return
      } else {
        this.changeMSg = 'sending'
        axios
          .post('PHPMailer/sendMail.php/send_mail', this.$qs.stringify(data))
          .then(obj => {
            window.console.log(obj)
            var obj = obj.data
            if (obj.code == 100) {
              this.$bvToast.toast(obj.msg, {
                title: `消息提醒`,
                variant: 'success',
                solid: true,
                toaster: 'b-toaster-top-center'
              })
              this.$bvModal.hide('modalContact')
              this.companyName = ''
              this.email = ''
              this.message = ''
              this.changeMSg = 'Send Message'
            } else {
              this.$bvToast.toast(obj.msg, {
                title: `消息提醒`,
                variant: 'danger',
                solid: true
              })
              this.changeMSg = 'Send Message'
            }
          })
        return false
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 获取吸顶元素的dom
      let header = this.$refs.header
      console.log(header.offsetHeight)
      // 吸顶元素到top的距离
      this.offsetTop = header.offsetTop
      // 元素自身的高度
      this.offsetHeight = header.offsetHeight

      // 监听滚动条
      window.addEventListener('scroll', this.handleScroll)
      setTimeout(()=>{
        if (this.$route.name == 'module_detail') {
          this.showChip = true
        } else {
          this.showChip = false
        }
        }, 400)
    })
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapState({
      activeMenu: state => state.activeMenu
    })
  }
}
</script>

<style>
.issFixed {
  position: fixed !important;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 4;
}
.myHeader.issFixed {
  background: #333;
}
.btn-info {
  background: #333 !important;
  border: 0 !important;
  color: white !important;
  padding: 10px !important;
  margin: 0 !important;
  border-radius: unset !important;
  text-align: left !important;
}
.accordiy {
  text-align: left;
}
.animated a {
  padding-left: 30px;
}
.card-body {
  padding: 0 !important;
}
.nbsec h5 {
  cursor: pointer;
}
.navbase a {
  color: white;
  width: 100%;
  /* height: 100%; */
  font-size: 14px;
}
.navbase li:hover {
}
.navbase a:hover {
  /* background: gray; */
  color: skyblue;
  text-decoration: none;
}
.myNav {
}
.navbase {
  display: flex;
  padding-left: 12%;
  width: 100%;
}
.navbase.special {
  flex-direction: column;
}
.navbase.special .row {
  margin-bottom: 20px;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}
.navbase .nbsec {
  padding: 0 20px 0 0;
  display: flex;
  width: 250px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  /* border-right: 1px solid black; */
}
.navbase .nbsec:last-child {
  border-right: none;
  padding-left: 0%;
}
.navbase .nbsec h5 {
  border-bottom: 1px solid lightgray;
  padding: 0px 0px 10px 0px;
  font-size: 18px;
  color: white;
  text-align: left;
  width: 72%;
}
/* .navbase .nbsec h5.nborder {
    border-bottom: 0;
} */
.navbase .nbsec ul {
  padding: 0;
  text-align: left;
}
.navbase .nbsec ul li {
  padding: 5px 0px;
  cursor: pointer;
}
.myNav .navbar-brand {
  padding: 0;
  height: 30px;
  display: flex;
}
.myNav .navbar-brand .img-fluid {
  max-width: unset;
  width: auto;
  height: 100%;
}

ul {
  list-style-type: none;
}
#nav-collapse,
#nav-collapse ul,
#nav-collapse ul li {
  height: 100%;
}
#nav-collapse ul .dropdown-menu {
  height: auto;
}
#nav-collapse ul li {
  height: auto;
  padding: 0 10px;
}
#nav-collapse ul li.chinese {
  padding: 0 20px;
}
.navbar-collapse {
  background: none !important;
}
.navbar-collapse:hover {
  background: #333 !important;
}
#nav-collapse > ul {
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0);
}
#nav-collapse,
#nav-collapse .navbar-nav li a {
  display: flex;
  align-items: center;
}

.navbar {
  padding: 0rem 1rem !important;
  height: 100%;
}
.nav-link {
  padding: 0rem 0.5rem;
  height: 100%;
}
.navbar-nav .el-header {
  width: 1200px !important;
  margin: 0 auto;
  padding: 0 !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0 !important;
}
.myHeader {
  width: 100% !important;
  position: relative;
  top: 0;
  left: 0;
  height: 60px;
  /* background: #2b2b2b !important; */
  z-index: 999;
}
.myHeader2 {
  width: 100% !important;
  position: relative;
  top: 0;
  left: 0;
  height: 60px;
  /* background: #333 !important; */
  z-index: 999;
}
.myHeader2:hover {
  background: #333 !important;
}
.myHeader2 #nav-collapse .navbar-nav li a {
  color: #333 !important;
}
.myHeader:hover {
  background: #333;
}
.myHeader2 .navbar-collapse:hover {
  background: unset !important;
}
.myHeader2 .navbar-collapse:hover a {
  color: white !important;
}
.myHeader2:hover #nav-collapse .navbar-nav li a {
  color: white !important;
}
.navbar-dark .navbar-nav .nav-link:hover {
  color: white !important;
  background-color: unset !important;
}
.navbar-dark .navbar-nav .nav-link {
  color: white !important;
}

.modal-footer {
  display: none !important;
}

.sendEmail {
  background: #3ab7cb !important;
  color: white !important;
}
.aiEngineer {
  /* height: 400px; */
  width: 100%;
  background-color: #333;
  background: rgba(51, 51, 51, 0.95);
  display: flex;
  padding: 30px 0 30px;
}

.aiEngineer .nav_le {
  flex: 1;
  border-right: 1px solid black;
}
.aiEngineer .nav_le ul {
  text-align: left;
  padding-left: 0;
}
.aiEngineer .nav_le ul li {
  padding: 10px 0 10px 60px;
  cursor: pointer;
}
.aiEngineer .nav_le ul li.active {
  background-color: lightgray;
}
.aiEngineer .nav_ri {
  flex: 4;
  padding: 0 40px;
}
.aiEngineer .nav_ri > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.aiEngineer .nav_ri > div h4 {
  padding: 0 0 10px;
  border-bottom: 1px solid black;
}
.aiEngineer .nav_ri > div ul {
  padding-left: 0;
  text-align: left;
  cursor: pointer;
}
.aiEngineer .nav_ri > div ul li {
  padding: 10px;
}
.contains {
  position: fixed;
  width: 100%;
  top: 60px;
  background: white;
  left: 0;
}
.list-group {
  font-size: 14px;
  font-weight: normal;
  text-align: left;
}
.background .drop {
  background-color: #333;
}
.background .drop .card .card-header a {
  font-size: 16px;
  font-weight: normal;
  background-color: #333;
}
</style>
<style scoped lang="scss">
.background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
  .list-group-item {
    text-align: left;
  }
  .drop {
    width: 50%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    background: #333;
    overflow: scroll;
    .card {
      padding: 0;
      margin: 0;
      border: none;
      .card-header {
        padding: 0 !important;
        margin: 0;
        border-radius: unset;
        a {
          background: #333;
          border: 0;
          color: white;
          padding: 10px;
          margin: 0;
          border-radius: unset;
          text-align: left;
        }
      }
    }
  }
  // 开
  .active {
    animation: opendoor 0.3s normal forwards;
  }
  @keyframes opendoor {
    from {
      right: -100%;
    }
    to {
      right: 0;
    }
  }
  // 关
  .close {
    animation: close 0.3s normal forwards;
  }
  @keyframes close {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
}
.btn:focus,
.btn.focus {
  box-shadow: unset;
}
.btn-info:not(:disabled):not(.disabled):active:focus,
.btn-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-info.dropdown-toggle:focus {
  box-shadow: unset;
}

.navbar-dark .navbar-toggler {
  background-color: #333;
  border: none;
}
</style>